import React from "react";
import Header from "../../components/header";
import ContactsComponent from "../../components/contacts";
import NavBar from "../../components/navBar";
import * as GS from "../../utils/globalStyles/background";
import { useUserContext } from "../../contexts/user/userContext";

const Contacts: React.FC = () => {
  const { state } = useUserContext();
  const { user } = state;

  return (
    <GS.BackgroundApp>
      <Header />
      <GS.BodyContainer>
        {/* undefined enquanto o usuário carrega (mostra o esqueleto) */}
        <ContactsComponent
          contacts={user ? (user.contacts ?? []) : undefined}
        />
      </GS.BodyContainer>
      <GS.NavContainer>
        <NavBar />
      </GS.NavContainer>
    </GS.BackgroundApp>
  );
};

export default Contacts;
